// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__+AH-Z","checkbox":"switch_checkbox__gQsAq","left":"switch_left__flP4d","right":"switch_right__fC+Jx","switchChecked":"switch_switchChecked__hJZRV"};